module.exports = __webpack_public_path__ + "img/success_8.5f0354b1.gif";